import { Component, Inject, input, PLATFORM_ID, WritableSignal } from '@angular/core'
import { isPlatformBrowser } from "@angular/common";
import { CookieConsentService, ModalService } from "@gea-waldviertler-website/shop-lib";
import { HeaderAndFooterResponseInterface, KeyValueInterface } from "@gea-waldviertler-website/gea-models";
import { SubscriptionsFormComponent } from "../form/subscriptions/subscriptions.component";
import { RefundFormComponent } from "../form/refund/refund.component";
import { resolveFooterLinkLabel } from "../helpers";

@Component({
    selector: 'gea-shop-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  date: Date
  expandableStates: KeyValueInterface = {}

  showCookieConsentPopup: WritableSignal<boolean>
  cmsResponse = input<HeaderAndFooterResponseInterface | undefined>(undefined)

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(ModalService) private modalService: ModalService,
    @Inject(CookieConsentService) private cookieConsentService: CookieConsentService,
  ) {
    let i=0
    while (i<=5) {
      this.expandableStates['ftexpand' + i] = 'collapsed'
      i++
    }

    this.date = new Date()
    this.showCookieConsentPopup = this.cookieConsentService.getShowPopupSignal()
    this.cookieConsentService.check()
  }

  getLinkLabel(item: { url?: string, text?: string }): string {
    return resolveFooterLinkLabel(item.text, item.url)
  }

  toggleExpander(id: string) {
    if (! isPlatformBrowser(this.platformId)) return

    if (this.expandableStates[id] == 'collapsing') {
      return;
    }

    if (this.expandableStates[id] == 'collapsed') { // expand
      this.expandableStates[id] = 'expanded'
    } else { // collapse
      this.expandableStates[id] = 'collapsed'
    }
  }
  
  openSubscriptionsModal() {
    let modal = this.modalService.show(SubscriptionsFormComponent, {
      title: "Zum Newsletter anmelden",
      subscribers: {
        submitEvent: function() {
          modal.close()
        }
      }
    })
  }

  openRefundModal() {
    let modal = this.modalService.show(RefundFormComponent, {
      title: "Widerruf",
      modalOptions: { fullscreen: 'sm', size: 'lg' },
      subscribers: {
        submitEvent: function() {
          modal.close()
        }
      }
    })
  }
}
